module.exports = __webpack_public_path__ + "static/img/4_03.a6769bac.png";